var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.923 13.577a.833.833 0 0 1 0 1.179l-3.334 3.333a.833.833 0 0 1-1.178 0l-1.667-1.666a.833.833 0 1 1 1.179-1.179L15 16.322l2.744-2.745a.833.833 0 0 1 1.179 0Z",
    fill: "#065F46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 9.167a7.5 7.5 0 1 1 15 0 6.742 6.742 0 0 1-.654 2.85.833.833 0 0 1-1.511-.701c.319-.688.498-1.407.498-2.15a5.833 5.833 0 1 0-11.666 0c0 1.839 1.113 3.557 2.67 4.907l2.868 2.485c.085.074.19.11.295.11a.833.833 0 0 1 0 1.667c-.493 0-.989-.172-1.386-.517l-2.868-2.486C4.007 13.826 2.5 11.688 2.5 9.168Z",
    fill: "#065F46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 9.167a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Z",
    fill: "#065F46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCheck);
export default __webpack_public_path__ + "static/media/nav-check.92dab771cda7a1b2d602e455b18067b2.svg";
export { ForwardRef as ReactComponent };